module.exports = __webpack_public_path__ + "static/media/edit-iconv2.c0af1c2d.svg";